import ProtectedRoute from "./wrapper.protectedRoutes";
import Layout from "../layout.main.jsx";

export default function ProtectedLayout() {
  return (
    <ProtectedRoute>
      <Layout />
    </ProtectedRoute>
  );
}
